import networkNMS from "public/network-services/icons/network-nms.png";
import { SimpleList } from "@/components/list";

const INSIGHTS_POINTS = [
  "AI-driven analytics for monitoring performance and resource utilization.",
  "Deep visibility into cloud and hybrid environments.",
  "Custom dashboards for centralized monitoring and reporting.",
];

const ALERTS_POINTS = [
  "Machine learning-based anomaly detection to prevent failures.",
  "Automated root cause analysis for identifying bottlenecks.",
  "Intelligent alerts & automated reporting for compliance and performance audits.",
];

const E2E_POINTS = [
  "Cloud-native observability for SaaS, multi-cloud, and hybrid deployments.",
  "Full-stack monitoring covering routers, switches, firewalls, and endpoints.",
  "Automated remediation workflows for faster incident resolution.",
];

const COMPLIANCE_POINTS = [
  "Zero-trust security framework for threat detection and mitigation.",
  "Continuous monitoring for GDPR, SOC 2, and industry compliance.",
  "Integrated firewall & DDoS protection for enhanced network security.",
];

export const SOLUTIONS_CONSTANTS = {
  title: "Features of Network Observability & NMS Solutions",
  list: [
    {
      content: <SimpleList points={INSIGHTS_POINTS} />,
      image: networkNMS,
      title: "Real-Time Network Insights",
    },
    {
      content: <SimpleList points={ALERTS_POINTS} />,
      image: networkNMS,
      title: "Proactive Detection & Automated Alerts",
    },
    {
      content: <SimpleList points={E2E_POINTS} />,
      image: networkNMS,
      title: "End-to-End Cloud & Hybrid Network Monitoring",
    },
    {
      content: <SimpleList points={COMPLIANCE_POINTS} />,
      image: networkNMS,
      title: "Compliance & Security Monitoring",
    },
  ],
};
